import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './AnnounceBanner.css';

const STORAGE_KEY = 'nxs_promo_dismissed';

export default function AnnounceBanner() {
  const [visible, setVisible] = useState(() => {
    try { return localStorage.getItem(STORAGE_KEY) !== '1'; } catch (_) { return true; }
  });

  function dismiss() {
    try { localStorage.setItem(STORAGE_KEY, '1'); } catch (_) {}
    setVisible(false);
  }

  if (!visible) return null;

  return (
    <div className="announce-bar" role="banner">
      <p className="announce-bar__text">
        <span className="announce-bar__gift">🎁</span>
        <strong>Offre de lancement</strong> — Site web livre en 7 jours a partir de&nbsp;
        <strong>150 000 FCFA</strong>
        <Link to="/devis" className="announce-bar__cta" onClick={dismiss}>
          Demander un devis →
        </Link>
      </p>
      <button
        className="announce-bar__close"
        onClick={dismiss}
        aria-label="Fermer l'annonce"
      >
        ✕
      </button>
    </div>
  );
}
